

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, VModel, Watch} from "vue-property-decorator";
import {IUserImported} from "@/store/modules/userDiffusionExpressModule";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {EDiffusionExpressCode} from "@/model/User/EDiffusionExpressCode";

/**
 * Shows the result of the diffusion express preview: which locker residents would be deactivated because they are not in the CSV (override locker users).
 */
@Component({})
export default class DiffusionExpressOverrideDialog extends Vue {

  @VModel()
  protected dialogShowing!: boolean;
  @Prop({default: () => []})
  protected preview!: IUserImported[];
  @Prop({default: ''})
  protected lockerName!: string;
  @Prop({default: false})
  protected loading!: boolean;
  @Prop({default: () => []})
  protected okCodes!: number[];

  protected typedCount: string = '';

  @Watch('dialogShowing')
  protected onShowingChanged() {
    this.typedCount = '';
  }

  // active residents of the locker whose email is in the csv (counted once even if repeated in the csv)
  protected get matchedCnt(): number {
    return new Set(
      this.preview
        .filter(each => each.code_import === EDiffusionExpressCode.RESIDENT_LINE)
        .map(each => (each.email || '').trim().toLowerCase())
    ).size;
  }

  protected get residentsCnt(): number {
    return this.matchedCnt + this.toDeactivate.length + this.notDeactivated.length;
  }

  // deactivating more than half of the residents usually means the wrong csv (or locker): ask to type the count
  protected get massDeactivate(): boolean {
    return this.toDeactivate.length > 0 && this.toDeactivate.length * 2 > this.residentsCnt;
  }

  protected get confirmable(): boolean {
    return !this.massDeactivate || this.typedCount.trim() === String(this.toDeactivate.length);
  }

  // header row is line 0; a KO there means the backend won't process nor deactivate anything
  protected get headerError(): IUserImported|undefined {
    return this.preview.find(each => each.line === 0 && each.code_import !== EDiffusionExpressCode.HEADER_OK);
  }

  protected get toDeactivate(): IUserImported[] {
    return this.preview.filter(each => each.code_import === EDiffusionExpressCode.WOULD_DEACTIVATE);
  }

  protected get toRestore(): IUserImported[] {
    return this.preview.filter(each => each.code_import === EDiffusionExpressCode.WOULD_RESTORE);
  }

  protected get notDeactivated(): IUserImported[] {
    return this.preview.filter(each => each.code_import === EDiffusionExpressCode.NOT_DEACTIVATED_ACTIVE_ORDERS);
  }

  protected get lineErrorsCnt(): number {
    return this.preview.filter(each => each.line !== null && !this.okCodes.includes(each.code_import)).length;
  }

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('users.userList.email'), align: 'start', sortable: false, value: 'email' },
      { text: this.$t('users.userList.firstName'), align: 'start', sortable: false, value: 'first_name' },
      { text: this.$t('users.userList.lastName'), align: 'start', sortable: false, value: 'last_name' },
    ];
  }

  protected onSubmit() {
    this.$emit('submit');
  }

  protected onCancel() {
    this.$emit('cancel');
    this.dialogShowing = false;
  }
}

